import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import {
  path,
  mergeDeepLeft,
  clone,
  findIndex,
  propEq,
} from 'ramda';
import Breadcrumbs from '../../common/Breadcrumbs';
import Table from '../../сomponents/Table';
import ConfirmAction from '../../common/ConfirmAction';
import { changeModalState } from '../../actions/modal'
import { deleteObject } from '../../actions/objectToDelete';
import { fetchReports, fetchReportExcelFile } from '../../api/reports';
import DatePicker from '../../common/DatePicker';
import Select from '../../common/Select';
import fields from './field';
import moment from 'moment';
import config from '../../config';
import Preloader from '../../common/Preloader';
import './style.css';
import CheckBox from "../../common/CheckBox";
import { deleteAllReports } from '../../actions/reports';


import { fetchDetailsWithoutProperty } from '../../api/dashboard';
import fieldsDashboard from '../Dashboard/fields';

export class Quotes extends Component {

  constructor(props) {
    super(props);
    this.onSearch = this.onSearch.bind(this);
    this.changeFormValue = this.changeFormValue.bind(this);
    this.onChangeItemsPerPage = this.onChangeItemsPerPage.bind(this);
    this.applyFilter = this.applyFilter.bind(this);
    this.getFilter = this.getFilter.bind(this);
    this.getReportItems = this.getReportItems.bind(this);
    this.onChangeCurrentPage = this.onChangeCurrentPage.bind(this);
    this.onSetField = this.onSetField.bind(this);
    this.setProjectFields = this.setProjectFields.bind(this);

    this.state = {
      items: Array.from([]),
      container: false,
      search: '',
      itemsPerPage: 10,
      fields: fields,
      loading: true,
      currentPage: 0,
      projectsFields: [],
      selectedFields: [],
    };

    this.columns = [
      'id',
      'workOrder',
      'financialInfo',
      'created',
      'dueDate',
      'status',
    ];

    this.columnNames = [
      'ID',
      'Work Order',
      'Financial Info',
      'Created',
      'Due Date',
      'Status',
    ];
  }

  onSearch(e) {
    e.preventDefault();
    this.setState({
      search: e.target.value,
    });
    return false;
  }

  onSetField(i, id, val) {
    const { projectsFields } = this.state;
    const newField = [...projectsFields];
    newField[i] = val;
    const selectedIds = [];
    for(let i = 0; i < newField.length; i ++) {
      if (newField[i].value) {
        selectedIds.push(newField[i].id)
      }
    }
    this.setState( { selectedFields: selectedIds, projectsFields: [...newField]}, () => {
     // this.reloadArchive(true);
    })
  }

  onChangeCurrentPage(currentPage) {
    this.setState({
      currentPage: currentPage,
    });
  }

  onChangeItemsPerPage(e) {
    e.preventDefault();
    this.setState({
      itemsPerPage: e.target.value,
    });
    return false;
  }

  getFilter() {
    let dateFrom = this.state.fields['filter_date_from'].value;
    let dateTo = this.state.fields['filter_date_to'].value;
    const { selectedFields } = this.state;
    if (dateTo) {
      dateTo = moment(dateTo).format('M/D/YYYY');
    }

    if (dateFrom) {
      dateFrom = moment(dateFrom).format('M/D/YYYY');
    }

    return {
      length: '-1',
      selected_filters: selectedFields,
      filter_date_option: this.state.fields['filter_date_option'].value || 'due',
      filter_date_from: dateFrom || '1/1/1990',
      filter_date_to:  dateTo || moment().add('1', 'year').format('M/D/YYYY'),
      'search[regex]': false,
      'search[value]': '',
      status: this.state.fields['status'].value || '',
      filter_fi: this.state.fields['filter_fi'].value || '',
    };
  }

  componentDidUpdate() {
    const itemsList = path(['reports', 'list', 'data'], this.props)
    const { loading } = this.state;
    if ( loading && itemsList ) {
      this.setState({ loading: false });
    }
  }

  componentWillMount() {
    const { getStages, deleteAllReports, list } = this.props;
    getStages();
    deleteAllReports();
    this.setState({loading: true});
    list(this.getFilter());
  }

  componentWillReceiveProps (newProps) {
    const lanes = path(['dashboard', 'lanes'], newProps);

    if (this.state.projectsFields.length === 0 && lanes) {
      this.setProjectFields(lanes);
    }

  }

  setProjectFields(lanes) {
    let selectedIds = [];
    const projectFields = [ fieldsDashboard.search, {
      label: 'Unassigned',
      placeholder: '',
      system: {
        name: '',
      },
      value: true,
      errors: [],
      type: 'lanes',
      id: 0,
      name: 'project_' + 0,
      rules: {
        title: '',
        required: false,
      }
    }];
    for (let i = 0; i < lanes.length; i++) {
      let currentField = {
        label: lanes[i].label,
        placeholder: '',
        system: {
          name: '',
        },
        value: true,
        errors: [],
        id: lanes[i].id,
        type: 'lanes',
        name: 'project_' + lanes[i].id,
        rules: {
          title: '',
          required: false,
        }
      };

      selectedIds.push(lanes[i].id);

      projectFields.push(currentField);
    }
    this.setState({
      selectedFields: selectedIds,
      projectsFields: projectFields,
    });
  }


  handlerEdit() {
    this.props.moveToEdit();
  }

  changeFormValue(field, newObject) {
    let stateClone = clone(this.state);
    stateClone.fields[field] = newObject;

    this.setState(mergeDeepLeft(stateClone, this.state));
  }

  // TODO: Move to backend
  fixDataForTable(data) {
    const newData = [];
    for (let i = 0; i < data.length; i++) {
      newData.push({
        id: data[i][0],
        workOrder: data[i][1],
        financialInfo: data[i][2],
        created: data[i][3],
        dueDate: data[i][4],
        status: data[i][5],
      });
    }
    return newData;
  }

  applyFilter() {
    this.props.deleteAllReports();
    this.setState({loading: true});
    this.props.list(this.getFilter());
  }

  getReportItems() {
    const itemsList = path(['reports', 'list', 'data'], this.props);

    if (!itemsList) {
      return null;
    }

    return (
      <Table
        items={this.fixDataForTable(itemsList)}
        columns={this.columns}
        columnNames={this.columnNames}
        itemsPerPage={this.state.itemsPerPage}
        search={this.state.search}
        actions={{}}
        currentPage={this.state.currentPage}
        onChangeCurrentPage={this.onChangeCurrentPage}
        onSearch={this.onSearch}
        onChangeItemsPerPage={this.onChangeItemsPerPage}
      />
    );
  }

  getProjects() {
    const projects = [];
    for (let i = 0; i < this.state.projectsFields.length; i++) {

      if (this.state.projectsFields[i].type == 'lanes') {

        projects.push(
            <div style={{
              display: 'inline-block',
              border: '1px solid rgba(0, 0, 0, 0.125)',
              borderRadius: '4px',
              padding: '5px',
              marginRight: '5px',
              marginBottom: '5px',
            }}>
              <CheckBox
                  customize={{
                    margin: '0',
                    paddingTop: '0',
                    paddingBottom: '0',
                  }}
                  key={i}
                  field={this.state.projectsFields[i]}
                  onChange={(e, val)=>this.onSetField(i, this.state.projectsFields[i].id, val)}
              />
            </div>
        );
      }
    }
    return projects;
  }


  render() {
    const {loading} = this.state;

    const mainPart = loading ? <Preloader show={true} type={'circle'}/> : this.getReportItems();

    const filename = path(['reports', 'excel', 'filename'], this.props) || '';
    let downloadExcel = null;
    let linesPart = this.getProjects();

    if (filename) {
      downloadExcel = (
        <button
          className="btn btn-rounded btn-icon ui-btn pull-right"
          style={{ borderRadius: '4px' }}>
          <a href={config.apiEndpoint + '/xlsx/' + filename}>
          <i className="fa fa-download"></i>
          Report
        </a>
        </button>
      );
    }

    return (
      <div style={{ paddingBottom: '25px' }}>
        <Breadcrumbs list={[
          { url: '/pages/dashboards', icon: 'dashboard', name: 'Dashboard' },
          { icon: 'account_balance_wallet', name: 'Reports' },
        ]} />
          <div className="card rounded">
            <div className="card-header rounded-top">
              Production Log Report
            </div>
            <div className="card-block">
              <div className="clearfix mb-3">
                {downloadExcel}
                <button
                  className="btn btn-rounded btn-icon ui-btn pull-right"
                  onClick={this.applyFilter}
                  style={{ marginRight: '10px', borderRadius: '4px', }}
                >
                  <i className="fa fa-filter"></i>
                  Apply filter
                </button>
              </div>
              <div className="row">
                  <div  className="col col-md-12">
                      <b>Projects:</b>
                  </div>
              </div>

              <div className="row" style={{paddingBottom: 10}}>
                <div  className="col col-md-12">
                    {linesPart}
                </div>
              </div>

              <div className="row">
                <div className="col col-md-12">
                  <Select
                    field={this.state.fields['filter_date_option']}
                    onChange={this.changeFormValue}
                  />
                </div>
                <div className="col col-md-6">
                  <DatePicker
                    field={this.state.fields['filter_date_from']}
                    onChange={this.changeFormValue}
                  />
                </div>
                <div className="col col-md-6">
                  <DatePicker
                    field={this.state.fields['filter_date_to']}
                    onChange={this.changeFormValue}
                  />
                </div>
                <div className="col col-md-12">
                  <Select
                    field={this.state.fields['status']}
                    onChange={this.changeFormValue}
                  />
                </div>
                <div className="col col-md-12">
                  <CheckBox
                    field={this.state.fields['filter_fi']}
                    onChange={this.changeFormValue}
                  />
                </div>
              </div>
              {mainPart}
              <ConfirmAction />
            </div>
          </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => {
  return {
    getStages: () => {
      fetchDetailsWithoutProperty()(dispatch);
    },
    list: (data) => {
      fetchReports(data)(dispatch);
      fetchReportExcelFile(data)(dispatch);
    },
    deleteAllReports: () => {
      dispatch(deleteAllReports())
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Quotes);



// WEBPACK FOOTER //
// ./src/containers/Reports/index.js